import styled, { css } from 'styled-components';
import type { FlattenSimpleInterpolation } from 'styled-components';
import { vars } from '../../theme';
import type { HBSurfaceVariant } from './HBSurface.types';

interface StyledSurfaceProps {
    $layoutCss?: Array<FlattenSimpleInterpolation | string>;
    $variant: HBSurfaceVariant;
}

const variantStyles: Record<HBSurfaceVariant, ReturnType<typeof css>> = {
    outlined: css`
        background-color: ${vars.colors.surface.container};
        border: 1px solid ${vars.colors.stroke.secondary};
    `,
    subtle: css`
        background-color: ${vars.colors.surface.itemInset};
        border: 1px solid ${vars.colors.stroke.secondary};
    `
};

export const StyledSurface = styled.div<StyledSurfaceProps>`
    box-sizing: border-box;
    ${({ $variant }) => variantStyles[$variant]}
    ${({ $layoutCss }) => $layoutCss}
`;
